module.exports = __webpack_public_path__ + "static/media/mastercard.0849df9e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/mastercard.svg
// module id = 798
// module chunks = 0